import { createReducer } from "@reduxjs/toolkit";
import { IClientCareState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: null,
  state: StoreState.None,
} as IClientCareState;

export const clientCareReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.clientCareFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.clientCareFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.clientCareFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
